import { render, staticRenderFns } from "./RegisterGraph.vue?vue&type=template&id=f18ec28c&"
import script from "./RegisterGraph.vue?vue&type=script&lang=js&"
export * from "./RegisterGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports